import { render, staticRenderFns } from "./ControlBoton.vue?vue&type=template&id=05a62ffb&"
import script from "./ControlBoton.vue?vue&type=script&lang=js&"
export * from "./ControlBoton.vue?vue&type=script&lang=js&"
import style0 from "./ControlBoton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports